import { UiEntityProperty } from '@shared/classes/entities/ui-entity-property';
import {UiEntityTableEntity} from '@shared/classes/entities/ui-entity-table-entity';

export class UiEntityTableCellComponentBase<T extends UiEntityTableEntity> {
  uiEntityData: T;
  uiEntityProperty: UiEntityProperty;
}
